import { FC } from 'react'

import { Checkbox } from '@makyoapp/makyo-ui'

import { BuilderComponentSetting } from '@/shared/builder'
import { SectionBackgroundGroupProps } from '@/shared/builder/default/section.default'
import { VariableSelectFieldSetting } from '@/pages/project-v2/layout/Editor/components/ComponentPanel/FieldSetting'

interface ImageBackgroundSelectProps {
  layer: SectionBackgroundGroupProps
  handleUpdate: (id: number, newValues: any) => Promise<void>
  id: string
  settingId: string
  imageSelectSettings: BuilderComponentSetting['imageSelectSettings']
}

export const ImageBackgroundSelect: FC<ImageBackgroundSelectProps> = ({
  handleUpdate,
  layer,
  id,
  settingId,
  imageSelectSettings,
}) => {
  return (
    <div className='space-y-4'>
      <VariableSelectFieldSetting
        id={id}
        settingId={settingId}
        variableSelectSettings={imageSelectSettings}
        value={layer.values.url}
        handleUpdate={(e: any) => handleUpdate(layer.id, { url: e })}
      />
      {layer.values.url && (
        <label className='flex items-center gap-2'>
          <Checkbox
            name='parallax'
            checked={(layer.values.parallax as boolean) ?? false}
            onClick={(e) => handleUpdate(layer.id, { parallax: e })}
            label='Parallax Effect'
          />
        </label>
      )}
    </div>
  )
}
